import { render, staticRenderFns } from "./CiLoader.vue?vue&type=template&id=3b42c8c2&scoped=true&"
import script from "./CiLoader.vue?vue&type=script&lang=js&"
export * from "./CiLoader.vue?vue&type=script&lang=js&"
import style0 from "./CiLoader.vue?vue&type=style&index=0&id=3b42c8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42c8c2",
  null
  
)

component.options.__file = "CiLoader.vue"
export default component.exports